import React, { useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

function NotificationUnread(props) {
  const [open, setOpen] = useState(null);

  const toggleNotification = id => () => {
    setOpen((o) => {
      if (id === o) return null;
      return id;
    });
  };

  const goToOrderDetail = (item) => {
    if(item.notification_type === 'OrderNotification'){
      props.history.push(`order-detail/${item.business_id}/${item.order_number}`)
    }
    else if(item.notification_type === 'ComplaintNotification'){
      props.history.push(`/complaint-detail/${item.business_id}/${item.complaint_id}`)
    }

  }

  return (
    <div>
      <div className="notification-state notification-unread">
        <p>New</p>
      </div>
      {
      props.readStatusFalseArray.map(item => (
        // <div key={item.id} id={item.id} onClick={toggleNotification(item.id)} className="notification-title-description notification-unread">
        (<div key={item.id} id={item.id} className="notification-title-description notification-unread" onClick={(item.notification_type === 'OrderNotification' || item.notification_type=='ComplaintNotification') ? () => goToOrderDetail(item) : toggleNotification(item.id)}>
          <div className="notification-title-date">
            <p className="notification-title">{item.title}</p>
            <p className="notification-date">{moment(item.created_at).format('DD MMM YYYY').toString()}</p>
          </div>
          {
            item.notification_type === 'OrderNotification' ?
            <div className="notification-description-detail">
              <p className="notification-description">{item.description}</p>
              {/* <p className={`notification-description ${open === item.id ? '' : 'short-notification-description'}`}>{item.description}</p> */}
              {/* <i className={`${open === item.id ? 'icon-arrow_down' : 'icon-arrow_right'}`} /> */}
              <i className="icon-arrow_right" />
            </div>
            :
            <div className="notification-description-detail">
              {/* <p className="notification-description">{item.description}</p> */}
              <p className={`notification-description ${open === item.id ? '' : 'short-notification-description'}`}>{item.description}</p>
              <i className={`${open === item.id ? 'icon-arrow_down' : 'icon-arrow_right'}`} />
              {/* <i className="icon-arrow_right" /> */}
            </div>
          }
        </div>)
      ))
      }
    </div>
  );
}

NotificationUnread.propTypes = {
  readStatusFalseArray: PropTypes.arrayOf(PropTypes.shape({})),
};

NotificationUnread.defaultProps = {
  readStatusFalseArray: [],
};


export default NotificationUnread;
